import { requestGet as wsRequestGet } from './_wsApiFetchData';

export async function fetchProductCategories(language, timeZone, cancelToken) {
  return toPascal(await wsRequestGet('/admin/categories/all', language, timeZone, null, cancelToken));
}

export async function fetchProductSchemes(language, timeZone, cancelToken) {
  return toPascal(await wsRequestGet('/admin/categories/schemes/all', language, timeZone, null, cancelToken));
}

function toPascal(o) {
  var newO, origKey, newKey, value
  if (o instanceof Array) {
    return o.map(function(value) {
        if (typeof value === "object") {
          value = toPascal(value)
        }
        return value
    })
  } else {
    newO = {}
    for (origKey in o) {
      if (o.hasOwnProperty(origKey)) {
        newKey = (origKey.charAt(0).toUpperCase() + origKey.slice(1) || origKey).toString()
        value = o[origKey]
        if (value instanceof Array || (value !== null && value.constructor === Object)) {
          value = toPascal(value)
        }
        newO[newKey] = value
      }
    }
  }
  return newO
}
